/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Tooltip from "./../Tooltip";
import RadioInputProps from "./RadioInputProps";
import "./RadioInput.scss";

export default function RadioInput(props: RadioInputProps) {
    return (
        <div className="lan-radioinput">
            <FormControlLabel
                className="lan-radioinput__label"
                control={<Radio disabled={props.readonly} onFocus={() => null} />}
                label={props.caption}
                checked={props.value}
                onChange={(_, checked) => props.onChange?.(checked)}
                onFocus={() => null}
            />
            {props.tooltip && (
                <div>
                    <Tooltip title={props.tooltip} />
                </div>
            )}
        </div>
    );
}
